import { SiInstagram, SiFacebook, SiTiktok, SiX, SiYoutube, SiPinterest, SiThreads, SiVisa, SiMastercard, SiAmericanexpress, SiApplepay, SiGooglepay, SiPaypal, SiKlarna, SiAfterpay } from "react-icons/si";

export const SOCIAL = [
  ["instagram", "Instagram", SiInstagram], ["facebook", "Facebook", SiFacebook], ["tiktok", "TikTok", SiTiktok], ["x", "X", SiX],
  ["youtube", "YouTube", SiYoutube], ["pinterest", "Pinterest", SiPinterest], ["threads", "Threads", SiThreads],
];

export const PAYMENTS = [
  ["visa", "Visa", SiVisa], ["mastercard", "Mastercard", SiMastercard], ["amex", "American Express", SiAmericanexpress],
  ["apple_pay", "Apple Pay", SiApplepay], ["google_pay", "Google Pay", SiGooglepay], ["paypal", "PayPal", SiPaypal],
  ["klarna", "Klarna", SiKlarna], ["clearpay", "Clearpay", SiAfterpay],
];
